module.exports = __webpack_public_path__ + "img/index_banner_6.8d23e841.jpg";